import React from 'react';
import './Section3.css';

const Section3 = () => (
  <section className="section3">
    <div className="section3-header">
      <h2>Mission & Values</h2>
      <p className="section3-mission">We build powerful, compliant, and innovative web solutions by combining expert development with smart, data-driven marketing strategies. We simplify complex challenges and drive long-term success in the U.S. market.</p>
    </div>
    <div className="section3-cards">
      <div className="section3-card">
        <div className="section3-card-icon" style={{background:'#e8eafe'}}>
          <img src="/feature_3.webp" alt="Partnership" className="feature-icon" />
        </div>
        <div className="section3-card-title">Go Big</div>
        <div className="section3-card-desc">We are all about dynamics and drive. We never settle for what has been achieved and always strive for more.</div>
      </div>
      <div className="section3-card">
        <div className="section3-card-icon" style={{background:'#fff7e6'}}>
          <img src="/feature_1.webp" alt="Quality" className="feature-icon" />
        </div>
        <div className="section3-card-title">Quality</div>
        <div className="section3-card-desc">We deliver high-performing, reliable solutions with a focus on regulatory compliance, efficiency, and dependability.</div>
      </div>
      <div className="section3-card">
        <div className="section3-card-icon" style={{background:'#ffe9f2'}}>
          <img src="/feature_2.webp" alt="Creativity" className="feature-icon" />
        </div>
        <div className="section3-card-title">Creativity</div>
        <div className="section3-card-desc">We embrace innovation and leverage market intelligence to deliver measurable results.</div>
      </div>
      <div className="section3-card">
        <div className="section3-card-icon" style={{background:'#e6fff7'}}>
          <img src="/feature_4.webp" alt="Trust" className="feature-icon" />
        </div>
        <div className="section3-card-title">Trust</div>
        <div className="section3-card-desc">We are committed to upholding the highest standards of data security, regulatory compliance, and privacy, ensuring our customers' confidence at every stage.</div>
      </div>
    </div>
    <button className="section-up" aria-label="Back to top" onClick={()=>window.scrollTo({top:0,behavior:'smooth'})}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="14" stroke="#4e69f8" strokeWidth="3"/><path d="M16 22V10M16 10L10 16M16 10L22 16" stroke="#4e69f8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </button>
  </section>
);

export default Section3;
